// ACTIONS PROCESSOR
// chunks through the store actions array and handles
/* global vueapp _*/

// import app from "./feathers.js";
import router from "./routes.js";
import store from "./store";
// import actionAuth from "./actionAuth";
import { EventBus } from "./eventBus";
import Vue from "vue";
// import ClipboardJS from "clipboard";
import VueCookie from "vue-js-cookie";
import VueScrollTo from "vue-scrollto";
Vue.use(VueCookie);

// const errors = require('@feathersjs/errors')
// import _ from 'lodash'

// QUEUE passed actions then run one
//TODO this is redundant, call store diectly
const queue = function(actions) {
  store.dispatch("ACTIONS_QUEUE", actions);
};

// PROCESS's the next action
const process = function(action) {
  // legacy support
  store.dispatch("ACTIONS_DO", {idThread: (action && action.idThread) || null})
};

// Dispatches an action
const dispatchAction = function(action) {
  // run any functions that are not function actions before calling the action
  if (action.function && action.action != "function") {
    action_function(action); // note, functions can mutate the action still
  }
  switch (action.action) {
    case "showModal":
      EventBus.$emit("showModal", action.options);
      Vue.nextTick(process(action));
      break;

    case "hideModal":
      EventBus.$emit("hideModal", action.options);
      // Vue.nextTick(process())
      break;

    case "showCardModal":
      store.dispatch("ADD_WINDOW", action);
      break;

    case "hideCardModal":
      EventBus.$emit("hideCardModal", action.options);
      break;
      
    case "function":
      Vue.nextTick(action_function(action));
      Vue.nextTick(process(action));
      break;

    case "showAlert":
      EventBus.$emit("toaster", action.options);
      Vue.nextTick(process(action));
      break;

    case "path":
      action_path(action);
      break;

    case "runUtilityHook":
      action_runUtilityHook(action);
      break;

    case "cookie":
      action_cookie(action);
      Vue.nextTick(process(action));
      break;

    case "runOnCompleteHook":
      action_runOnCompleteHook(action);
      break;

    case "clipboard":
      action_clipboard(action);
      Vue.nextTick(process(action));
      break;

    case "showStripeCheckout":
      action_showStripeCheckout(action);
      Vue.nextTick(process(action));
      break;

    case "validate":
      action_validate(action);
      break;

    case "scrollTo":
      action_scrollTo(action);
      Vue.nextTick(process(action));
      break;

    case "throttle":
    case "debounce":
      action_debounceThrottle(action);
      Vue.nextTick(process(action));
      break;

    case "setFocus":
      setTimeout(() => Vue.nextTick(action_setFocus(action)), 400);
      // Vue.nextTick(action_setFocus(action))
      Vue.nextTick(process(action));
      break;

    case "wait":
      action_wait(action);
      break;

    case "authLogin":
    case "authLogout":
      
    case "authRegister":
    case "authForgot":
    case "authReset":
      
    case "authResend":
    case "authResendVerify":
    case "authVerify":
      action_auth(action);
      break;

    case "mapInfoWindow":
      EventBus.$emit(action.action, action);
      Vue.nextTick(process(action));
      break;

    case "emit":
      EventBus.$emit(action.options.eventName, action.options.message);
      Vue.nextTick(process(action));
      break;
      
    case "messageSend":
      action_message(action, false);
      Vue.nextTick(process(action));
      break;
      
  case "messageSendAnonChannel":
      action_message(action, true);
      Vue.nextTick(process(action));
      break;
      
    case "channelJoinAnon":
      action_channelJoinAnonymous(action);
      Vue.nextTick(process(action));
      break;
      
    case "channelLeaveAnon":
      action_channelLeaveAnonymous(action);
      Vue.nextTick(process(action));
      break;
    
    case "oauthLoginHook":
    case "authLoginOauth":
      action_authLoginOauth(action);
      break;
      
    case "consoleError":
      action_consoleError(action);
      break;
      
    case "pwaCustomInstall":
      action_pwaCustomInstall(action);
      Vue.nextTick(process(action));
      break;
      
    case "pwaPromptInstall":
      action_pwaPromptInstall(action);
      Vue.nextTick(process(action));
      break;
      
    case "pwaPushNotificationSend":
      action_pwaPushNotificationSend(action);
      Vue.nextTick(process(action));
      break;
      
    case "pwaPromptPushPermission":
      action_pwaPromptPushPermission(action);
      Vue.nextTick(process(action));
      break;

    case "":
    case "namedAction":
    case null:
    case undefined:
      EventBus.$emit("processNamedAction", action);
      break;

    default:
    action.idThread ? store.commit('SET_PENDINGTRHEADS', action.idThread) : null
    BF.errorThrow (10112, `No action handler found for this action ${action.action}` , action)
  }
};

const action_pwaPromptPushPermission = async function (action) {
  if ('Notification' in window && 'PushManager' in window) {
    Notification.requestPermission().then(function(permission) {
      if (permission === 'granted') {
        const {pushDataGetKey, pushDataRegister} = require('./feathers.js');
        return window.registerSW .pushManager.getSubscription()
          .then(async (subscription) => {
            if(subscription) {
              return subscription;
            }
            const vapidPublicKey = await pushDataGetKey.find();
            
            return window.registerSW.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: vapidPublicKey
            });
          })
          .then(subscription => {
            pushDataRegister.create({
                subscription: subscription
              });
          })
          .catch(e => {
            console.log('Error saving subscription to server.\n', e)
            BF.errorThrow(e);
          });
      }
    });
  }
  else {
    alert('Browser does not support push notifications.');
  }
};

const action_pwaPushNotificationSend = async function (action) {
  const {pushNotificationSend} = require('./feathers.js');
  
  try {
    var options = Object.assign({}, action.options);
    
    delete options.actions;
    options.actions = action.options.actionButtons;
    // console.log('@action_pwaPushNotificationSend options: ', options)
    delete options.actionButtons;
    
    var result = await pushNotificationSend.create(options);
    console.log('@pwaPushNotificationSend result: ', result)
  }
  catch (e) {
    BF.errorThrow(e)
  }
};

const action_pwaPromptInstall = function (action) {
  window.deferredPrompt.prompt();

  window.deferredPrompt.userChoice.then( choiceResult => {
    //check to change onAccepted_actions
    if (choiceResult.outcome === 'accepted') {
      action?.options?.onAccepted ? action.options.onAccepted() : null;
    } else {
      action?.options?.onDismissed ? action.options.onDismissed() : null;
    }
    window.deferredPrompt = null;
  });
};

//Create new action that will block default prompt and set new custom prompt
//save deferredPrompt to window so it can be used globally
const action_pwaCustomInstall = function (action) {
  window.addEventListener('beforeinstallprompt', e => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    window.deferredPrompt = e;
    action?.options?.beforeinstallprompt ? action.options.beforeinstallprompt() : null;
  });
};

const action_consoleError = function (action) {
  console.error(action.options.message);
};

const action_authLoginOauth = function (action) {
  const getQueryParams = require("Js/bfUtilities").getQueryParams;
  getQueryParams().oauthtoken ? window.localStorage.setItem('feathers-jwt', getQueryParams().oauthtoken) : null;
  getQueryParams().errorMessage ? BF.errorThrow (10160, getQueryParams().errorMessage , 'OAuth on login hook error.') : null;
  setTimeout(() => {
    if (window.localStorage.getItem('feathers-jwt')) {
        store.dispatch("ONLOGINHOOK", {action})
        .then(result => {
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread)
          BF.errorThrow (10158, error.message , 'OAuth on login hook error.');
        });
    }
  }, 200);
};

const action_channelLeaveAnonymous = function (action) {
  let { messageRemoveUserService } = require('./feathers.js');
  
  //Treat error properly
  if (!("channel" in action.options)) {
    BF.errorThrow (10130, 'Missing channel' , action.options)
  }
  
  messageRemoveUserService.create({channel: action.options.channel, anonymous: true, users: []});
};

const action_channelJoinAnonymous = function (action) {
  let { messageAddUserService } = require('./feathers.js');
  
  //Treat error properly
  if (!("channel" in action.options)) {
    BF.errorThrow (10130, 'Missing channel' , action.options)
  }
  
  messageAddUserService.create({channel: action.options.channel, anonymous: true, users: []});
};

const action_message = function (action, anonymousChannel) {
  let { messageService } = require('./feathers.js');
  
  if (!store.getters.isOnline()) {BF.errorThrow(10902, 'User has no internet connection', 'Offline')}
  
  if (!Array.isArray(action.options.channels)) {
    BF.errorThrow (10131, 'Channels need to be an array' , action.options.channels);
    return;
  }

  const message = {
      channels: action.options.channels,
      actions: action.options.actions,
      model: action.options.model,
      app: action.options.app
    };
    
  messageService.create({message: message, anonymousChannel: anonymousChannel})
  .catch(error => {
    BF.errorThrow (10132, error.message , 'Send message error.');
  });
};

const action_runUtilityHook = async function(action) {
  EventBus.$emit("runUtilityHook", action, function(result) {
    // console.log('@callback runUtilityHook results: ', result.results)
  });
};

const action_runOnCompleteHook = function(action) {
  EventBus.$emit("runOnCompleteHook", action, function(result) {
    // console.log('@action_runOnCompleteHook callback', result.results)
  });
};

const action_validate = function(action) {
  EventBus.$emit("validate", action);
};

const action_wait = function(action) {
  setTimeout(() => Vue.nextTick(process(action)), action.options.ms);
};

const action_showStripeCheckout = function(action) {
  EventBus.$emit("showStripeCheckout_" + action.options.formId, action);
};

const action_path = function(action) {
  store.commit('SET_PENDINGTRHEADS', action.idThread);
  action.options = Object.assign(action.options, action.options.options); // map any additional options
  delete action.options.options; // not needed but may in future
  
  // Is targeted to a window
  if (action.options.windowName) {
    store.commit("updateWindow", action.options);
  }
  // is PATH
  else if (action.options.path) {
    router.push(action.options.path)
    .catch(e => {
      store.commit('SET_PENDINGTRHEADS', action.idThread);
      BF.errorThrow(10141, 'Path action error, duplicated navigation blocked', 'Path action error, trying to navigate to current page')
    });
  }
  // is REDIRECT
  else if (action.options.url) {
    if (action.options.sameWindow) {
      window.location = action.options.url;
    } else {
      //default to new tab
      // window.open(action.options.url, "_blank");
      window.open(action.options.url, action.options.name || "_blank", action.options.features)
    }
  } else {
    BF.errorThrow(10140, 'Path action error, path or url is empty ....', 'Path action error, missing path')
  }
};

const action_clipboard = function(action) {
  EventBus.$emit("doClipboard", action, function(result) {});
};

const action_setFocus = function(action) {
  action.options.select
    ? document.querySelector("[id^=" + action.options.elementId + "]").select()
    : document.querySelector("[id^=" + action.options.elementId + "]").focus(); // starts with ...
};

const action_cookie = function(action) {
  let result = Vue.cookie[action.options.action](
    action.options.name,
    action.options.value,
    action.options.daysOrOptions
  );
  BF.socketDisconnect()
  BF.socketConnect()
};

const action_scrollTo = function(action) {
  var cancelScroll = VueScrollTo.scrollTo(
    action.options.element,
    action.options.duration,
    action.options.options
  );
};

const action_function = function(action) {
  EventBus.$emit("executeFunction", action);
};

const action_auth = function(action) {
  const idActiveWindow = store.state.wndw.idWndwActive;
  const targetWindow = store.state.wndw.windows.find(window => window.id === idActiveWindow);
  var model = targetWindow.formSchema.model;
  var email = model.email;
  var password = model.password;
  var token
  Vue.set(formGen.formSchema.model, "authMessage", "");
  switch (action.action) {
    case "authLogin":
      store
        .dispatch("LOGIN", {
          email,
          password
        })
        .then(result => {
          delete formGen.formSchema.model.password;
          store.dispatch("ONLOGINHOOK", {action})
          .then(result => {
            // Vue.nextTick(process(action));
          })
          .catch(error => {
            store.commit('SET_PENDINGTRHEADS', action.idThread);
            BF.errorThrow(10157, error.message, 'On login hook error.');
          });
        })
        .catch(error => {
          // BF.errorThrow(10150, error.message, 'Invalid login attempt.', action.idThread);
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10150, error.message, 'Invalid login attempt.');
        });
      break;

    case "authLogout":
      store
        .dispatch("LOGOUT", {action})
        .then(result => {
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10151, error.message, 'Logout error.');
        });
      break;

    case "authRegister":
      store
        .dispatch("SIGNUP", {
          email: email,
          password: password
        })
        .then(result => {
          delete formGen.formSchema.model.password;
          delete formGen.formSchema.model.password2;
          var payload = _.cloneDeep(formGen.formSchema);
          delete payload.form.hookSetName; // else fm script captures incorrectly
          payload.user = result;
          store.dispatch("ONREGISTERHOOK", {payload, action});
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10152, error.message, 'Signup error.');
        });
      break;

    case "authForgot":
      store
        .dispatch("ONPWRESETHOOK", {email, action})
        .then(result => {
          Vue.set(
            formGen.formSchema.model,
            "authMessage",
            "Check your email for a reset link"
          );
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10153, error.message, 'Password reset hook error.');
        });
      break;

    case "authReset":
      token =
        formGen.formSchema.model.token || vueapp.$route.params.optionalSlug || vueapp.$route.query.token;
      store
        .dispatch("RESETPW", { token, password, action })
        .then(result => {
          delete formGen.formSchema.model.password;
          delete formGen.formSchema.model.password2;
          Vue.set(formGen.formSchema.model, "authMessage", "Your password has been reset successfully!");
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10154, error.message, 'Password reset error.');
        });
      break;

    case "authResendVerify":
    case "authResend":
      store
        .dispatch("RESENDVERIFYSIGNUP", {email, action})
        .then(result => {
          Vue.set(
            formGen.formSchema.model,
            "authMessage",
            "Check your email for a verification link"
          );
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10155, error.message, 'Resend verify signup error.');
        });
      break;
      
    case "authVerify":
      token =
        formGen.formSchema.model.token || vueapp.$route.params.optionalSlug || vueapp.$route.query.token;
      store
        .dispatch("VERIFYSIGNUP", { token, action })
        .then(result => {
          Vue.set(formGen.formSchema.model, "authMessage", "Email Verified");
          // Vue.nextTick(process(action));
        })
        .catch(error => {
          store.commit('SET_PENDINGTRHEADS', action.idThread);
          BF.errorThrow(10156, error.message, 'Verify signup error.');
        });
      break;

  }
};

var debounceThrottle = {};
const action_debounceThrottle = function(action) {
  
  let namedAction = action.options.namedAction, currentThread = action.idThread;
  let remainingSameThread;
  if (!namedAction) {
    let splitArray = _.partition(vueapp.$store.state.actions.actions, {idThread: currentThread})
    remainingSameThread = splitArray[0];
    
    vueapp.$store.dispatch('ACTIONS_CLEAR', action)
  }
  else {
    remainingSameThread = [{action: 'namedAction', name: namedAction}]
  }
  
  //conitnue code below
  
  const callback = function () {
    store.dispatch("ACTIONS_QUEUE", {actions: remainingSameThread, idThread: action.idThread});
  };
  
  let name = action.options.name || 'bfdebounce';
  if (!debounceThrottle[name]) {
     debounceThrottle[name] = _[action.action](callback,
      action.options.wait,
      action.options
     );
  }
  
  debounceThrottle[name]()

};


export const actions = {
  process: process,
  queue: queue,
  dispatchAction: dispatchAction
};
